import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import HistoryItemJob from '@/components/formats/RirekishoParts/HistoryItemJob.vue'
import NewRirekishoResetDialog from '@/components/format-edit/new-rirekisho/NewRirekishoResetDialog.vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { useDesignRirekishoJobDetail } from '@/composables/format-edit/useDesignRirekishoJobDetail'
import type { BasicData } from '@/utils/format-edit/basicData'


export default /*#__PURE__*/_defineComponent({
  __name: 'DesignRirekishoJobDetailHistoryCard',
  props: {
    currentCardId: null,
    basicData: null,
    previewErrors: null,
    subtitle: null
  },
  setup(__props: any) {



const descriptionMaxLength = 80
const formatData = useRirekishoFormatData()
const jobResetVisible = ref(false)
const {
  activeHistoryItem,
  addJobHistory,
  deleteJobHistory,
  moveJobHistory,
  resetJobHistories,
  addProjectHistory,
  deleteHistoryDetail,
  moveJobHistoryDetail,
  activateHistoryItem
} = useDesignRirekishoJobDetail(formatData)

return { __sfc: true,descriptionMaxLength, formatData, jobResetVisible, activeHistoryItem, addJobHistory, deleteJobHistory, moveJobHistory, resetJobHistories, addProjectHistory, deleteHistoryDetail, moveJobHistoryDetail, activateHistoryItem, HistoryItemJob, NewRirekishoResetDialog }
}

})